// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1aBvu","footer":"ModalInfo_footer__yyGqE"};